export default __webpack_public_path__ + "static/media/industrial.caf76b85.jpeg";